import {
  ClientDeviceType,
  apiService,
  isTouchDevice as _isTouchDevice,
} from "@blacknut/javascript-sdk/dist";

export const isTouchDevice = () => {
  // based on input params
  switch (apiService.userAgent.client) {
    case ClientDeviceType.PHONE:
    case ClientDeviceType.TABLET:
      return true;
    case ClientDeviceType.TV:
    case ClientDeviceType.DESKTOP:
      return false;
  }
  // based on ua
  return _isTouchDevice();
};

export default isTouchDevice;
